import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Card from './Card'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import PropTypes from 'prop-types'
import Spinner from './Spinner'
import Typeahead from './Typeahead'
import { scrollToTop } from '../util/helpers'
import styles from '../styles/RecsForm.module.scss'
import { useEffect } from 'react'
import { v4 } from 'uuid'

const RecsForm = ({
  commander,
  commander2,
  decklist,
  errors,
  isLoading,
  onSubmit,
  setCommander,
  setCommander2,
  setDecklist,
}) => {
  useEffect(() => {
    scrollToTop()
  }, [])

  return (
    <Form onSubmit={onSubmit}>
      <Form.Row>
        <Form.Group as={Col}>
          <Form.Label>Commander</Form.Label>
          <Typeahead
            clearButton
            onChange={async (e) => setCommander(e[0])}
            placeholder='Enter Commander'
            type='commanders'
            value={commander}
          />
          {commander && (
            <div className={styles.commanderPad}>
              <Card hideLabel hideName name={commander} />
            </div>
          )}
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>Commander 2 (optional)</Form.Label>
          <Typeahead
            clearButton
            onChange={async (e) => setCommander2(e[0])}
            placeholder='Enter Commander 2 (Partner)'
            type='partners'
          />
          {commander2 && (
            <div className={styles.commanderPad}>
              <Card hideLabel hideName name={commander2} />
            </div>
          )}
        </Form.Group>
      </Form.Row>
      <Form.Group>
        <Form.Label>Decklist</Form.Label>
        <Form.Control
          as='textarea'
          onChange={(e) => setDecklist(e.target.value)}
          placeholder='Accepts several formats, e.g. ...                                                                                                                                                                                                                                                                                                                                                                    ...                                                                                                                                                                                                                                                                                                                                                                                                                                                                      Sol Ring                                                                                                                                                                                                                                                                                                                                                                                                                                                        1 Sun Titan                                                                                                                                                                                                                                                                                                                                                                                                                                          1x Vandalblast'
          rows={10}
          value={decklist}
        />
      </Form.Group>
      {errors.map((error) => (
        <Alert className={styles.alert} key={v4()} variant='danger'>
          {error}
        </Alert>
      ))}
      <div className={styles.submit}>
        <Button disabled={isLoading} type='submit' variant='primary'>
          {isLoading ? <Spinner /> : 'Submit'}
        </Button>
      </div>
    </Form>
  )
}

RecsForm.propTypes = {
  commander: PropTypes.object,
  commander2: PropTypes.object,
  commanderName: PropTypes.string.isRequired,
  commanderName2: PropTypes.string.isRequired,
  decklist: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  setCommander: PropTypes.func.isRequired,
  setCommander2: PropTypes.func.isRequired,
  setCommanderName: PropTypes.func.isRequired,
  setCommanderName2: PropTypes.func.isRequired,
  setDecklist: PropTypes.func.isRequired,
}

export default RecsForm
